import React, { useState } from 'react';
import axios from 'axios';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import '../styles/armsform.css';
// Import the logo image
import logoImage from '../assets/images/logo.jpg'; // Adjust the path according to your project structure

const ArmsLedger = () => {
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [summaryData, setSummaryData] = useState([]);
    const [message, setMessage] = useState('');

    const handleGenerate = async () => {
        if (!fromDate || !toDate) {
            setMessage('Please select both From and To dates'); 
            return;
        }

        try {
            const response = await axios.post('https://chaman.gob.pk/eac_backend/arms.php', {
                action: 'get_summary',
                from_date: fromDate,
                to_date: toDate
            });

            if (response.data.status === 'success') {
                setSummaryData(response.data.data);
                setMessage('');
            } else {
                setMessage(response.data.message || 'Error fetching data');
            }
        } catch (error) {
            setMessage('An error occurred while fetching the data');
            console.error(error);
        }
    };

    const exportToPDF = () => {
        const doc = new jsPDF('landscape');
        const pageWidth = doc.internal.pageSize.getWidth();

        // Add Logo Image (Centered)
        const imageWidth = 0.80 * 25.4; // Adjust to your logo size
        const imageHeight = 0.6 * 25.4; // Adjust to your logo size
        const xCenter = (pageWidth - imageWidth) / 2;
        doc.addImage(logoImage, 'JPEG', xCenter, 10, imageWidth, imageHeight);

        // Main Heading (Centered, Bold, and Dark Color)
        doc.setFontSize(21.5);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 0, 0); // Dark color
        doc.text('OFFICE OF THE DEPUTY COMMISSIONER CHAMAN', pageWidth / 2, 37, { align: 'center' });

        // Add Date Range
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0);
        doc.text(`Date From: ${fromDate || 'N/A'}`, pageWidth - 60, 15);
        doc.text(`Date To: ${toDate || 'N/A'}`, pageWidth - 60, 22);

        // Table Headers
        const headers = [["S.No.", "Token ID", "License No", "Date", "Name", "Father Name", "CNIC", "Address", "Status"]];

        // Table Data
        const tableData = summaryData.map((entry, index) => [
            (index + 1).toString(),
            entry.token_id,
            entry.license_no,
            entry.date,
            entry.name,
            entry.father_name,
            entry.cnic,
            entry.address,
            entry.status
        ]);

        // Generate the table
        doc.autoTable({
            head: headers,
            body: tableData,
            startY: 45,
            theme: 'grid',
            headStyles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] },
            styles: {
                fontSize: 10,
                textColor: [0, 0, 0],
            },
            columnStyles: {
                0: { halign: 'center' },
            },
        });

        doc.save('Arms_Ledger_Summary.pdf');
    };

    return (
        <div className="passport-ledger-container">
            {/* <h2>Arms License Ledger</h2> */}
            {message && <p className="message">{message}</p>}

            <div className="date-range">
                <div className="date-input">
                    {/* <label id='ledgerl1'>From Date</label> */}
                    <input
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                    />
                </div>
                <div className="date-input">
                    {/* <label id='ledgerl2'>To Date</label> */}
                    <input
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                    />
                </div>
                <button id='ledgerb' onClick={handleGenerate}>Generate</button>
                <button id='ledgerb' onClick={exportToPDF}>Export</button>
            </div>

            {summaryData.length > 0 && (
                <div className="summary-table">
                    {/* <h3>Summary</h3> */}
                    <table id='st'>
                        <thead>
                            <tr>
                                <th>Token ID</th>
                                <th>License No</th>
                                <th>Date</th>
                                <th>Name</th>
                                <th>Father Name</th>
                                <th>CNIC</th>
                                <th>Address</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {summaryData.map((item) => (
                                <tr key={item.token_id}>
                                    <td>{item.token_id}</td>
                                    <td>{item.license_no}</td>
                                    <td>{item.date}</td>
                                    <td>{item.name}</td>
                                    <td>{item.father_name}</td>
                                    <td>{item.cnic}</td>
                                    <td>{item.address}</td>
                                    <td>{item.status}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {/* <button onClick={exportToPDF}>Export to PDF</button> */}
                </div>
            )}
        </div>
    );
};

export default ArmsLedger;
